import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UsersIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
const packages = [{
  id: 1,
  title: 'Istanbul Explorer',
  image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
  price: '$799',
  duration: '5 days',
  groupSize: '10 people',
  startDate: 'Multiple dates',
  featured: true
}, {
  id: 2,
  title: 'Dubai Luxury Experience',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  price: '$1,299',
  duration: '7 days',
  groupSize: '8 people',
  startDate: 'Multiple dates',
  featured: true
}, {
  id: 3,
  title: 'Thailand Beach Getaway',
  image: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1139&q=80',
  price: '$899',
  duration: '6 days',
  groupSize: '12 people',
  startDate: 'Multiple dates',
  featured: true
}];
const FeaturedPackages = () => {
  return <section className="py-16" data-id="element-49">
      <div className="container mx-auto px-4" data-id="element-50">
        <div className="flex justify-between items-center mb-12" data-id="element-51">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-52">
            Featured Packages
          </h2>
          <Link to="/packages" className="flex items-center text-red-600 hover:text-red-800" data-id="element-53">
            View all packages
            <ArrowRightIcon size={16} className="ml-2" data-id="element-54" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-55">
          {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow" data-id="element-56">
              <div className="relative" data-id="element-57">
                <img src={pkg.image} alt={pkg.title} className="w-full h-56 object-cover" data-id="element-58" />
                {pkg.featured && <span className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-59">
                    Featured
                  </span>}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4" data-id="element-60">
                  <div className="text-white font-bold text-xl" data-id="element-61">
                    {pkg.title}
                  </div>
                  <div className="text-white font-semibold" data-id="element-62">
                    {pkg.price}{' '}
                    <span className="text-sm font-normal" data-id="element-63">per person</span>
                  </div>
                </div>
              </div>
              <div className="p-6" data-id="element-64">
                <div className="flex flex-col space-y-3 mb-4" data-id="element-65">
                  <div className="flex items-center text-gray-600" data-id="element-66">
                    <ClockIcon size={16} className="mr-2 text-red-600" data-id="element-67" />
                    <span data-id="element-68">{pkg.duration}</span>
                  </div>
                  <div className="flex items-center text-gray-600" data-id="element-69">
                    <UsersIcon size={16} className="mr-2 text-red-600" data-id="element-70" />
                    <span data-id="element-71">Max {pkg.groupSize}</span>
                  </div>
                  <div className="flex items-center text-gray-600" data-id="element-72">
                    <CalendarIcon size={16} className="mr-2 text-red-600" data-id="element-73" />
                    <span data-id="element-74">{pkg.startDate}</span>
                  </div>
                </div>
                <Link to={`/packages/${pkg.id}`} className="block w-full bg-red-600 hover:bg-red-700 text-white text-center py-2 rounded-md font-medium" data-id="element-75">
                  View Details
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FeaturedPackages;